import React, { FC, useContext } from 'react'
import css from './QuizHeader.module.scss'
import ArrowIcon from '../../../public/static/icons/arrow-left.svg'
import CloseIcon from '../../../public/static/icons/close.svg'
import { QuizContext } from '../../../contexts/quizProvider'

const QuizHeader: FC<{
  closeHandler: React.Dispatch<React.SetStateAction<boolean>>
}> = ({ closeHandler }) => {
  const {
    step,
    final,
    setStep,
    setFinal,
    setQuizAnswers,
    quizLength,
    setResult,
    q1,
    q2,
    q3,
    q4,
    loading,
  } = useContext(QuizContext)

  const getQuestion = () => {
    switch (step) {
      case 1:
        return q1.question
      case 2:
        return q2.question
      case 3:
        return q3.question
      case 4:
        return q4.question
    }
  }

  return (
    <div>
      <div className={css.proggress_wrapper}>
        <div className={css.arrow}>
          {step > 1 && (
            <button
              type="button"
              className={css.arrow_wrapper}
              onClick={() => {
                if (final) {
                  setStep(quizLength)
                  setQuizAnswers((prev) => {
                    prev.pop()
                    return prev
                  })
                } else {
                  setStep((prev) => --prev)
                  setQuizAnswers((prev) => {
                    prev.pop()
                    return prev
                  })
                }
                setFinal(false)
                setResult(null)
              }}
            >
              <ArrowIcon />
              {final && <span>назад</span>}
            </button>
          )}
        </div>

        {!final && <div className={`${css.proggress} ${css['step' + step]}`} />}
        <button
          type="button"
          className={css.close}
          onClick={() => {
            setStep(1)
            setFinal(false)
            closeHandler(false)
            setQuizAnswers([])
            setResult(null)
          }}
        >
          <CloseIcon />
        </button>
      </div>
      {!loading && (
        <>
          <p className={css.num}>{final ? 'Поздравляем!' : `вопрос ${step}`}</p>
          <p className={`${css.quesion} h1 apoc`}>
            {final ? 'Вам подойдет' : getQuestion()}
          </p>
        </>
      )}
    </div>
  )
}

export default QuizHeader
